
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/assets/partnerships/alloy",
      function () {
        return require("private-next-pages/docs/assets/partnerships/alloy.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/assets/partnerships/alloy"])
      });
    }
  